import { ArrowUpCircle, X } from 'lucide-react';
import { useAppStoreUpdate } from '../hooks/useAppStoreUpdate';

/**
 * iOS-only banner that appears automatically when a newer build is live on the
 * App Store. Dismissible, but reappears on next launch/resume until the user
 * updates. No-ops on web/PWA.
 */
export default function AppUpdateBanner() {
  const { updateAvailable, latestVersion, openStore, dismiss } = useAppStoreUpdate();

  if (!updateAvailable) return null;

  return (
    <div
      className="fixed left-0 right-0 z-[100600] px-3"
      style={{ top: 'env(safe-area-inset-top, 0px)', paddingTop: '8px' }}
    >
      <div
        className="mx-auto max-w-md flex items-center gap-3 rounded-2xl bg-blue-600 text-white px-4 py-3 shadow-lg"
        style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, sans-serif' }}
      >
        <ArrowUpCircle className="h-5 w-5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-[14px] font-semibold leading-tight">Update available</div>
          <div className="text-[12px] text-blue-100 leading-tight">
            {latestVersion ? `Version ${latestVersion} is ready` : 'A new version is ready'} in the App Store
          </div>
        </div>
        <button
          type="button"
          onClick={openStore}
          className="flex-shrink-0 rounded-xl bg-white text-blue-700 text-[13px] font-semibold px-3 py-1.5 active:scale-95 transition-transform"
          style={{ WebkitTapHighlightColor: 'transparent' }}
        >
          Update
        </button>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          className="flex-shrink-0 text-blue-100 hover:text-white p-1"
          style={{ WebkitTapHighlightColor: 'transparent' }}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
